import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SecureIdExpiredError extends CodedError {
  static get errorName() {
    return errorCodes.secureIdExpiredError.code;
  }

  constructor(message: string = errorCodes.secureIdExpiredError.message) {
    super(message);
    this.code = errorCodes.secureIdExpiredError.code;
    this.message = `${message} ${errorCodes.secureIdExpiredError.code}`;
    this.name = errorCodes.secureIdExpiredError.name;
  }
}
